"use client";

import React from "react";
import { create_placeholder_icon } from "@/components/icons/icons-utils/create-placeholder-icon";
import { CUSTOM_LAYOUT_ICON_COMPONENT_BY_NAME } from "@/components/icons/icons-utils/custom-layout-icons";
import { ICON_COMPONENT_BY_NAME_PLACEHOLDERS } from "@/components/icons/icons-utils/icon-placeholder-registry.generated";
import type { PlaceholderIconProps } from "@/components/icons/icons-utils/icon-props";

// MARK: ICON_COMPONENT_BY_NAME
/**
 * Full lookup: generated icon shells plus layout SVGs (corners, margin, reset, mouse-scroll).
 *
 * **Reuse scope:** Project-wide — `Icon` primitive, Lexical, and `@/components/icons` consumers.
 */
export const ICON_COMPONENT_BY_NAME: Record<string, React.FC<PlaceholderIconProps>> = {
    ...ICON_COMPONENT_BY_NAME_PLACEHOLDERS,
    ...CUSTOM_LAYOUT_ICON_COMPONENT_BY_NAME,
};

const MissingIcon = create_placeholder_icon("Missing");

// MARK: get_icon_component
/**
 * Resolves a canonical PascalCase name (usually `ICONS` enum value) to a component.
 *
 * **Reuse scope:** Project-wide.
 */
export function get_icon_component(
    name: string,
): React.FC<PlaceholderIconProps> {
    return ICON_COMPONENT_BY_NAME[name] ?? MissingIcon;
}
